import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeGroupAction } from '../../reducers/actions';
import { GroupService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_GROUP),
    switchMap(action =>
      GroupService.delete(action.groupId, store).pipe(
        map(() => removeGroupAction(action.groupId)),
        catchError(retryAuthentication(action$, 'epics/groups/deleteGroup'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/groups/deleteGroup.js